import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-welcome-homepage-modal',
  templateUrl: './welcome-homepage-modal.component.html',
  styleUrls: ['./welcome-homepage-modal.component.less']
})
export class WelcomeHomepageModalComponent {

  constructor(private activeModal: NgbActiveModal, private router: Router) { }

  cancelModal() {
    this.activeModal.close(false);
  }

  routeToNewProjectPage(data : any) {
    if(data) {
      this.router.navigate(['/user/projects'],{queryParams: { newUser : true }});
      localStorage.setItem('newUser', JSON.stringify({ newUser : true, newProject : true }));
    } else {
      this.router.navigate(['/user/projects'],{queryParams: { newUser : true }})
      localStorage.setItem('newUser', JSON.stringify({ newUser : true, newProject : false }));
    }
    this.activeModal.close(false);
  }

}
